var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlarmCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#906DF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 19.3335C30 24.8563 25.5228 29.3335 20 29.3335H11.8556C11.2782 29.3335 10.9894 29.3335 10.8272 29.2171C10.6798 29.1112 10.5942 28.9662 10.5728 28.786C10.5492 28.5877 10.6995 28.3154 11.0002 27.7708C11.0862 27.6149 11.1512 27.4791 11.1994 27.352C11.4782 26.6171 11.5113 26.3806 11.4453 25.5973C11.4073 25.1462 11.1128 24.2253 10.5239 22.3835C10.2212 21.4366 10 20.3851 10 19.3335C10 13.8106 14.4772 9.3335 20 9.3335C25.5228 9.3335 30 13.8106 30 19.3335ZM14.5555 17.1113C14.5555 16.559 15.0033 16.1113 15.5555 16.1113H24.4444C24.9967 16.1113 25.4444 16.559 25.4444 17.1113C25.4444 17.6636 24.9967 18.1113 24.4444 18.1113H15.5555C15.0033 18.1113 14.5555 17.6636 14.5555 17.1113ZM14.5555 21.5557C14.5555 21.0034 15.0033 20.5557 15.5555 20.5557H20C20.5523 20.5557 21 21.0034 21 21.5557C21 22.108 20.5523 22.5557 20 22.5557H15.5555C15.0033 22.5557 14.5555 22.108 14.5555 21.5557Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmCommunity);
export default __webpack_public_path__ + "static/media/icon_alarm_community.48b461b630ccf0addbec2ffcb7c085f0.svg";
export { ForwardRef as ReactComponent };